import axios, { AxiosResponse } from "axios";
import { ArrayFromEnvelope, configService, ObjectFromEnvelope } from "./config.service";
import { SalaryRecord } from "../models/salaryRecord";
import { SalaryType } from "../models/salaryType";
import { convertDateOnlyToUtc } from "../utils/dateUtils";

class SalaryService {
  async fetchSalaryRecords(fromDate: Date, toDate: Date): Promise<SalaryRecord[]> {
    return new Promise((resolve, reject) => {
      axios
        .get<SalaryRecord[]>(
          configService.APIInstitutionUrl(
            "salary_records.json?institution_id=" +
              configService.institutionId() +
              "&from_date=" +
              convertDateOnlyToUtc(fromDate) +
              "&to_date=" +
              convertDateOnlyToUtc(toDate)
          )
        )
        .then((response: AxiosResponse) => {
          resolve(SalaryRecord.fromJSONArray(ArrayFromEnvelope<SalaryRecord>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async fetchSalaryRecord(id: number): Promise<SalaryRecord[]> {
    return new Promise((resolve, reject) => {
      axios
        .get<SalaryRecord[]>(
          configService.APIInstitutionUrl(
            "salary_records.json?institution_id=" + configService.institutionId() + "&id=" + id
          )
        )
        .then((response: AxiosResponse) => {
          resolve(SalaryRecord.fromJSONArray(ArrayFromEnvelope<SalaryRecord>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async fetchSalaryTypes(): Promise<SalaryType[]> {
    return new Promise((resolve, reject) => {
      axios
        .get<SalaryType[]>(
          configService.APIInstitutionUrl(
            "salary_types.json?institution_id=" + configService.institutionId()
          )
        )
        .then((response: AxiosResponse) => {
          resolve(SalaryType.fromJSONArray(ArrayFromEnvelope<SalaryType>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async createSalaryRecord(salaryRecord: SalaryRecord): Promise<SalaryRecord> {
    return new Promise((resolve, reject) => {
      axios
        .post<SalaryRecord>(
          configService.APIInstitutionUrl("salary_records.json"),
          salaryRecord.convertToPostObject()
        )
        .then((response: AxiosResponse) => {
          resolve(SalaryRecord.fromJSON(ObjectFromEnvelope<SalaryRecord>(response.data)));
        })
        .catch((error) => reject(error));
    });
  }

  async updateSalaryRecord(salaryRecord: SalaryRecord): Promise<SalaryRecord> {
    return new Promise((resolve, reject) => {
      axios
        .put<SalaryRecord>(
          configService.APIInstitutionUrl("salary_records/" + salaryRecord.id + ".json"),
          salaryRecord.convertToPutObject()
        )
        .then((response: AxiosResponse) => {
          resolve(SalaryRecord.fromJSON(ObjectFromEnvelope<SalaryRecord>(response.data)));
        })
        .catch((error) => reject(error));
    });
  }

  async deleteSalaryRecord(salaryRecordId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .delete<SalaryRecord>(
          configService.APIInstitutionUrl("salary_records/" + salaryRecordId + ".json")
        )
        .then((response: AxiosResponse) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  }
  async createSalaryType(salaryType: SalaryType): Promise<SalaryType> {
    return new Promise((resolve, reject) => {
      axios
        .post<SalaryType>(
          configService.APIInstitutionUrl("salary_types.json"),
          salaryType.convertToPostObject()
        )
        .then((response: AxiosResponse) => {
          resolve(SalaryType.fromJSON(ObjectFromEnvelope<SalaryType>(response.data)));
        })
        .catch((error) => reject(error));
    });
  }
  async updateSalaryType(salaryType: SalaryType): Promise<void> {
    return new Promise((resolve, reject) => {
      axios
        .put<SalaryType>(
          configService.APIInstitutionUrl("salary_types/" + salaryType.id + ".json"),
          salaryType.convertToPutObject()
        )
        .then(() => {
          resolve();
        })
        .catch((error) => reject(error));
    });
  }
  async deleteSalaryType(salaryTypeId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .delete<SalaryType>(
          configService.APIInstitutionUrl("salary_types/" + salaryTypeId + ".json")
        )
        .then((response: AxiosResponse) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  }
  async fileSalary(salaryIds: number[]): Promise<void> {
    return new Promise((resolve, reject) => {
      axios
        .post<SalaryRecord>(
          configService.APIInstitutionUrl("salary_records/file_salary_records.json"),
          {
            salary_records: salaryIds.toString()
          }
        )
        .then(() => {
          resolve();
        })
        .catch((error) => {
          return reject(error);
        });
    });
  }
}

export const salaryService: SalaryService = new SalaryService();
